import React from 'react';
import PropTypes from 'prop-types';

import { TranslatedCopy } from '../../intl/TranslatedCopy';

import { GamedayLogo, Link, Icon } from '../../components';

export const OrderReturnsNavigation = ({ backTo, backToText, onBackClickHandler }) => (
  <div className='orderReturnsNav bg-white flex-container row pt4-sm pb4-sm u-full-width center z2'>
    <Link to={backTo} onClick={onBackClickHandler} className='orderReturnsNav__backTo flex-container row align-center'>
      <Icon name='chevron-left' alt='back icon' />{' '}
      <span data-desc='orderReturnsNav__backTo_span'>
        <TranslatedCopy id={backToText} />
      </span>
    </Link>
    <GamedayLogo />
  </div>
);

OrderReturnsNavigation.propTypes = {
  backTo: PropTypes.string.isRequired,
  backToText: PropTypes.string.isRequired,
  onBackClickHandler: PropTypes.func.isRequired
};

export default OrderReturnsNavigation;
